import client from "./client";
import {
  EmployeeWorkOrderPayRateResponse,
  PostEmployeeWorkOrderPayRateRequest,
} from "../interfaces/WorkOrderPayRate";

/**
 * API client for the per-employee Work Order hourly pay rate editor (TAS-290).
 * Direct-api-import path, no manager/dataLayer — matches src/api/prevailingWage.ts.
 */

export async function getEmployeeWorkOrderPayRate(
  employeeID: number
): Promise<EmployeeWorkOrderPayRateResponse> {
  const response = await client.get<EmployeeWorkOrderPayRateResponse>(
    `admin/employees/${employeeID}/workOrderPayRate`
  );
  return response.data;
}

export async function postEmployeeWorkOrderPayRate(
  employeeID: number,
  body: PostEmployeeWorkOrderPayRateRequest
): Promise<EmployeeWorkOrderPayRateResponse> {
  const response = await client.post<EmployeeWorkOrderPayRateResponse>(
    `admin/employees/${employeeID}/workOrderPayRate`,
    body
  );
  return response.data;
}

/** TAS-292 follow-up: remove the override — employee follows the system (PAN) rate again. */
export async function revertEmployeeWorkOrderPayRate(
  employeeID: number,
  effectiveDate: string
): Promise<EmployeeWorkOrderPayRateResponse> {
  const response = await client.post<EmployeeWorkOrderPayRateResponse>(
    `admin/employees/${employeeID}/workOrderPayRate/revert`,
    { effectiveDate }
  );
  return response.data;
}
